import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters.js'
import mutations from './mutations.js'
import actions from './actions.js'
import houseModule from './modules/house'
import orderModule from './modules/order'

Vue.use(Vuex)

var store = new Vuex.Store({
  state: {
    host: process.host,
    userId: 0, // 用户Id
    accessToken: '', // 用户token
    headerTitle: 'PMS',
    userInfo: {}, // 用户信息
    // 用户权限及身份
    permissions: {},
    commonConfigs: {},
    pageInfo: {
      firstUrl: window.location.href,
      refererUrl: document.referrer
    },
    currentRoute: null,
    fromRoute: null,
    showAuthModal: false,
    showAuthClose: false
  },
  getters,
  mutations,
  actions,
  modules: {
    house: houseModule,
    order: orderModule
  }
})

export default store
